// extracted by mini-css-extract-plugin
module.exports = {"container":"DelayedButton_container__1QXW_","progress":"DelayedButton_progress__1OquO"};